export default "__VITE_ASSET__BWdpFOMI__"